import type { Participant, Questionnaire, Stage } from "@/types/api-types"

export const getCurrentStage = (participant: Participant): Stage => {
  // The API guarantees every Participant has at least one stage, so the last
  // element is always defined. Asserting non-null lets callers drop redundant
  // null guards and `stage?.foo` chains.
  return participant.stages.at(-1)!
}

export const getQuestionnaire = (
  questionnaires: Questionnaire[] | undefined,
  surveyType: string,
): Questionnaire | undefined => {
  return questionnaires?.find((questionnaire) => questionnaire.portalUrlParamName === surveyType)
}
